<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">QR Code</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/qrcode">QR Code</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <p><strong>Please show this QR code to pay directly from your wallet:</strong></p>

                <img v-bind:src="qrcode()" class="qr-image" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'qrcode',
  methods: {
    qrcode: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return 'https://admin.goldenspoon.co.za/assets/uploads/qr_image/' + user.parent.device_identifier + '.png'
    }
  }
}
</script>

<style scoped>
.qr-image {
  margin:0 auto;
  width:100%;
}
</style>
